import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './app/providers/AppProviders';
import { router } from './app/router';
import { AppErrorBoundary } from './components/feedback/AppErrorBoundary';
import { PwaUpdatePrompt } from './components/feedback/PwaUpdatePrompt';
import { ToastProvider } from './components/feedback/ToastProvider';
import './styles/app.css';
import './styles/professional.css';
import './styles/experience.css';
import './styles/exam.css';

const root = document.getElementById('root');
if (!root) throw new Error('Elemento raiz não encontrado.');

createRoot(root).render(
  <StrictMode>
    <AppErrorBoundary>
      <AppProviders>
        <ToastProvider>
          <RouterProvider router={router} />
          <PwaUpdatePrompt />
        </ToastProvider>
      </AppProviders>
    </AppErrorBoundary>
  </StrictMode>,
);
